import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useIntl } from "react-intl";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ServiceView from "./components/ServiceView";
import LandingView from "./components/LandingView";
import { UserReducerActionType } from "./reducers/userReducer";
import { UserContext } from "./contexts/UserContext";
import { getStoreItem, removeStoreItem, setStoreItem } from "./utils/storageUtils";

const HomePage = () => {
  const { userState, userDispatch } = useContext(UserContext);
  const [initialized, setInitialized] = useState(false);
  const [shouldLoadInfo, setShouldLoadInfo] = useState(false);
  const [shouldCheckInfo, setShouldCheckInfo] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [params, setParams] = useSearchParams();
  const { formatMessage } = useIntl();

  useEffect(() => {
    document.title = formatMessage({ id: "label_lost_device_protection" });
    const userInfo = ["firstName", "lastName", "expiration"];
    params.forEach((value, key) => {
      userInfo.includes(key) ? userDispatch({ type: UserReducerActionType.UPDATE_USER_INFO, payload: { [key]: value } }) : null;
    });
    setParams("");
    setInitialized(true);
  }, []);

  useEffect(() => {
    if(initialized) {
      if(!(userState && Object.keys(userState).length === 0 && Object.getPrototypeOf(userState) === Object.prototype)) { // check object
        setStoreItem("userInfo", userState);
        setShouldCheckInfo(true);
      } else {
        setShouldLoadInfo(true);
      }
    }
  }, [initialized]);

  useEffect(() => {
    if(shouldLoadInfo) {
      const localUserInfo = getStoreItem("userInfo");
      localUserInfo ? userDispatch({ type: UserReducerActionType.UPDATE_USER_INFO, payload: localUserInfo } ) : null;
      setShouldCheckInfo(true);
    }
  }, [shouldLoadInfo]);

  useEffect(() => {
    if(shouldCheckInfo) {
      const { expiration } = userState;
      if(expiration) {
        const expirationTime = parseInt(expiration);
        if(expirationTime * 1000 < Date.now()) {
          userDispatch({ type: UserReducerActionType.CLEAR_USER_INFO, payload: { } });
          removeStoreItem("userInfo");
          setLoggedIn(false);
        } else {
          setLoggedIn(true);
        }
      } else {
        setLoggedIn(false);
      }
      setShouldCheckInfo(false);
    }
  }, [shouldCheckInfo]);

  return (
    <>
      <Header />
      <div id="content">
        { loggedIn ? <ServiceView /> : <LandingView /> }
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
